<template>
  <div class="container-vehicle-info">
    <div class="row container-vehicle-info__main-header">
      <div class="col-sm-12 col-md-12 col-lg-11 d-flex d-flex align-items-baseline justify-content-between">
        <h4 class="mb-0">{{ $t('order_vehicle') }}</h4>
        <div class="font-big link-choose-vehicle" data-bs-toggle="modal" data-bs-target="#selectVehicleModal">
          {{ $t('select_other') }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-4">
        <img class="container-vehicle-info__main-photo"
             :src="vehicle.vehicle_main_image ? vehicle.vehicle_main_image.path : ''"
             alt="selected-vehicle-photo">
      </div>

      <div class="col-sm-6 col-md-6 col-lg-8 container-vehicle-info__main-info-1">
          <div class="col-8 container-vehicle-info__name font-big">{{ vehicle.make + ' ' + vehicle.model }}</div>
          <div class="col-8 container-vehicle-info__price font-big">{{ vehicle.price }}
            {{ $t('eur_h') }}</div>
          <div class="col-8 container-vehicle-info__free-items">
            <VehicleCardFreeItemWrapperComponent class="justify-content-start gap-3"></VehicleCardFreeItemWrapperComponent>
          </div>

      </div>

    </div>
  </div>

  <ModalComponent :show-title="false" :id-data="'selectVehicleModal'">
    <template #body-content>
      <div class="modal-body">
        <VehicleSelectWrapperComponent :is-main-modal="false"></VehicleSelectWrapperComponent>
      </div>
    </template>
  </ModalComponent>
</template>

<script lang="ts">
import './vehicleInfo.scss';

import {defineComponent, type PropType} from "vue";

// @ts-ignore
import VehicleCardFreeItemWrapperComponent from "../../../components/vehicleCardFreeItemWrapper/VehicleCardFreeItemWrapperComponent";
// @ts-ignore
import ModalComponent from "../../../components/modal/ModalComponent";
// @ts-ignore
import VehicleSelectWrapperComponent from "../../../components/vehicleSelectWrapper/VehicleSelectWrapperComponent";

import type {IApiResponseVehicle} from "@/interfaces/apiResponseInterfaces/IApiResponseVehicle.interface";

export default defineComponent({
  name: 'VehicleInfoComponent',
  components: {
    ModalComponent,
    VehicleCardFreeItemWrapperComponent,
    VehicleSelectWrapperComponent
  },
  props: {
    vehicle: {
      type: Object as PropType<IApiResponseVehicle> | PropType<null>,
      required: true
    }
  },

  data() {
    return {}
  },

  mounted() {},

})
</script>